import { Component } from '@angular/core';

@Component({
    selector: 'app-geozone-info',
    templateUrl: './geozone-info.component.html',
    styleUrls: ['./geozone-info.component.css'],
    standalone: false
})
export class GeozoneInfoComponent {

}
